import AIHistory from '../components/ai/AIHistory';

export default function AIHistoryPage() {
    return <AIHistory />;
}